import { Flex, Heading, Image, SimpleGrid, Text } from '@chakra-ui/react';
import {
  allCommodities,
  Commodity,
  COMMODITY_CATEGORY_BG_GRADIENTS,
  CommodityCategory,
} from 'helpers/fakeData';
import Link from 'next/link';
import { memo } from 'react';

interface Props {
  category: CommodityCategory;
  commodityHref: (id: string) => string;
}

const CommodityCard = ({ commodity, href }: { commodity: Commodity; href: string }) => {
  return (
    <Link href={href} style={{ textDecoration: 'none' }}>
      <Flex
        direction="column"
        gap={2}
        p={3}
        bg="surface.background"
        borderRadius="xl"
        borderColor="border.light"
        borderWidth="1px"
        cursor="pointer"
        _hover={{ borderColor: 'border.dark' }}
      >
        <Image boxSize="60px" src={commodity.image} alt={commodity.name} />
        <Text fontSize="lg" fontWeight="medium">
          {commodity.ticker}
        </Text>
        <Text color="text.secondary" fontWeight="medium" truncate lineClamp={1}>
          {commodity.name}
        </Text>
      </Flex>
    </Link>
  );
};

const ExploreCommodities = ({ category, commodityHref }: Props) => {
  const commodities = getCommoditiesForCategory(category);
  return (
    <Flex
      direction="column"
      gap={4}
      background={COMMODITY_CATEGORY_BG_GRADIENTS[category]}
      p={4}
      borderRadius="xl"
      borderColor="border.light"
      borderWidth="1px"
    >
      <Heading>{`${getCategoryLabel(category)}`}</Heading>
      <SimpleGrid columns={{ base: 2, md: 5 }} gap={4}>
        {commodities
          .filter((commodity) => commodity.category === category)
          .map((commodity) => (
            <CommodityCard
              key={commodity.id}
              commodity={commodity}
              href={commodityHref(commodity.id)}
            />
          ))}
      </SimpleGrid>
    </Flex>
  );
};

const getCategoryLabel = (category: CommodityCategory) => {
  switch (category) {
    case 'agriculture':
      return 'Agriculture';
    case 'construction':
      return 'Construction';
    case 'metals':
      return 'Metals';
    case 'energy':
      return 'Energy';
    default:
      return category;
  }
};

const getCommoditiesForCategory = (category: CommodityCategory) => {
  return allCommodities.filter((commodity) => commodity.category === category);
};

export default memo(ExploreCommodities);
